module.exports = __webpack_public_path__ + "img/Group4_26_english.636f3c87.jpg";